import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import TextButtonGroupVertSplit from "./TextGroup/TextButtonGroupVertSplit";
import TextButtonGroupHorz from "./TextGroup/TextButtonGroupHorz";
import TextButtonGroupHorzSplit from "./TextGroup/TextButtonGroupHorzSplit";
import TextButtonGroupVertical from "./TextGroup/TextButtonGroupVertical";

const TextButtonGroup = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Text Button Group
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          Text Button Group only button texts are separated by divider without
          background filled inside.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <TextButtonGroupHorz />
          </Grid>
          <Grid item xs={6}>
            <TextButtonGroupHorzSplit />
          </Grid>
          <Grid item xs={6}>
            <TextButtonGroupVertical />
          </Grid>
          <Grid item xs={6}>
            <TextButtonGroupVertSplit />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default TextButtonGroup;
